<template>
  <div>
    <!-- 请假最大时长设定 -->
    <Form :label-width="150" label-position="left">
      <Row>
        <Col :xs="24" :sm="24" :md="24" :lg="7">
          <FormItem label="地区/城市名称">
            <Select v-model="formItem.cityCode" :clearable="true" placeholder="" :disabled="loading">
              <Option :value="item.citycode" v-for="(item, i) in CityLabel" :key="i">{{ item.citycname }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="24" :lg="7" offset="1">
          <FormItem label="请假类型">
            <Select v-model="formItem.lvType" :clearable="true" placeholder="" :disabled="loading">
              <Option :value="item.code" v-for="(item, i) in LeaveLabel" :key="i">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col offset="1">
          <Button @click="totalNum=0,pageInfo.pageNo=1,search()" :disabled="loading"><!-- 检索 -->{{$t('Search')}}</Button>
        </Col>
      </Row>
    </Form>
    <!-- <FormTitle titleText="各地休假信息维护管理"/> -->
    <Table border ref="selection" :loading="loading" :columns="columns" :data="data">
      <template slot-scope="{ row, index }" slot="action">
        <Button type="warning" icon="md-create" size="small" @click="editBtn(row, index)">编辑</Button>
        <Button type="error" icon="md-trash" size="small" @click="deletBtn(row, index)">删除</Button>
      </template>
    </Table>
    <div style="display: flex; justify-content: space-between;margin: 10px 0">
      <Page :total="this.totalNum" @on-change="pageChange" />
      <Button icon="md-add" @click="addData" :disabled="loading">新增</Button>
    </div>
    <Modal v-model="showSetting" width="600" :title="itemTitle == 1 ? '新增' : '编辑'">
      <Form style="margin: 10px 40px 0 40px" :label-width="185" label-position="left">
        <FormItem label="地区/城市名称">
          <Select v-model="LvDayMessage.cityCode" :clearable="true" placeholder="" >
            <Option :value="item.citycode" v-for="(item, i) in CityLabel" :key="i">{{ item.citycname }}</Option>
          </Select>
        </FormItem>
        <FormItem label="请假类型">
          <Select v-model="LvDayMessage.lvType" :clearable="true" placeholder="">
            <Option :value="item.code" v-for="(item, i) in LeaveLabel" :key="i">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="最大休假时长">
          <InputNumber v-model="LvDayMessage.lvDate" style="width:100%" :min="0" precision="0"></InputNumber>
        </FormItem>
        <FormItem label="是否顺延">
          <Checkbox v-model="LvDayMessage.bePostpone"></Checkbox>
        </FormItem>
        <!-- <FormItem label="是否带薪">
          <Checkbox v-model="LvDayMessage.beSalary"></Checkbox>
        </FormItem> -->
      </Form>
      <div slot="footer">
        <Button @click="saveLeaveData">保存</Button>
        <Button @click="cancelLeaveData">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import formTitle from "../../formPageComponents/formTitle.vue";
export default {
  components: { formTitle },
  data() {
    return {
      columns: [
        {
          title: "地区/城市编码",
          key: "cityCode",
          align: "center",
        },
        {
          title: "地区/城市名称",
          key: "cityName",
          align: "center",
        },
        {
          title: "请假类型",
          key: "lvTypeName",
          align: "center",
        },
        {
          title: "请假时长",
          key: "lvDate",
          align: "center",
        },
        {
          title: "是否顺延",
          key: "bePostpone",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              params.row.bePostpone == "0" ? "否" : params.row.bePostpone == "1" ? "是" : ""
            );
          },
        },
        // {
        //   title: "是否带薪",
        //   key: "beSalary",
        //   align: "center",
        //   render: (h, params) => {
        //     return h(
        //       "span",
        //       params.row.beSalary == "0" ? "否" : params.row.beSalary == "1" ? "是" : ""
        //     );
        //   },
        // },
        {
          title: "假期管理",
          slot: "action",
          align: "center",
          width: "200",
        },
      ],
      data: [
        {
          banben: "1",
          year: "2021",
          status: "1",
          achTypeId: "1",
        },
      ],
      formItem: {},
      LvDayMessage: {
        lvDate:null
      },
      showSetting: false,
      loading: false,
      achTypeList: [],
      effectiveList: [],
      evaTypeList: [],
      itemTitle: 0,
      slotAction: 0,
      openEdit: false,
      index: 0,
      row: {},
      LeaveLabel:[],
      totalNum: 0, //table数据总条数
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10, //每页数据条数
      },
      CityLabel:[
        
      ],
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      this.loading = true;
      let obj = {
        ...this.formItem,
        ...this.pageInfo,
      }
      axios.post("/LvDaysMaster/selectLvDaysMaster", obj).then((res) => {
        this.loading = false;
        this.data = res.data
        this.totalNum = +(res.pageInfo.total)
      });
      // 下拉框
      axios.post("/LvDaysMaster/selectLvDaysMasterLabel", {}).then((res) => {
        this.loading = false;
        this.LeaveLabel = res.LeaveLabel
        this.CityLabel = res.CityList
      });
    },
    pageChange(val){
      this.pageInfo.pageNo = val
      this.search()
    },
    addData() {
      this.showSetting = true;
      this.itemTitle = 1;
      this.LvDayMessage = {};
      this.LvDayMessage.lvDate = null
    },
    editBtn(row, index) {
      this.showSetting = true;
      this.itemTitle = 2;
      this.LvDayMessage = { ...row };
      this.LvDayMessage.bePostpone = !!(+this.LvDayMessage.bePostpone) 
      this.LvDayMessage.beSalary = !!(+this.LvDayMessage.beSalary)
    },
    saveLeaveData() {
      this.loading = true;
      this.LeaveLabel.forEach(item=>{
        if(this.LvDayMessage.lvType == item.code){
          this.LvDayMessage.lvTypeName = item.name
        }
      })
      this.CityLabel.forEach(item=>{
        if(this.LvDayMessage.cityCode == item.citycode){
          this.LvDayMessage.cityName = item.citycname
        }
      })
      let obj = {
        bePostpone: this.LvDayMessage.bePostpone==true ? '1' : '0', 
        beSalary: this.LvDayMessage.beSalary==true ? '1' : '0',
        cityCode: this.LvDayMessage.cityCode,
        lvType: this.LvDayMessage.lvType,
        lvDate: this.LvDayMessage.lvDate,
        cityName: this.LvDayMessage.cityName,
        lvTypeName: this.LvDayMessage.lvTypeName,
        id: this.LvDayMessage.id,
        createBy: this.itemTitle == 1 ? JSON.parse(sessionStorage.getItem("userInfo")).userId : null,
        updateBy: JSON.parse(sessionStorage.getItem("userInfo")).userId,
      };
      // 新增
      if (this.itemTitle == 1) {
        axios.post("/LvDaysMaster/insertLvDaysMaster", obj).then((res) => {
          if(res){
            this.search();
            this.showSetting = false;
          }
          this.loading = false;
        });
        // 编辑
      } else if (this.itemTitle == 2) {
        axios.post("/LvDaysMaster/updateLvDaysMaster", obj).then((res) => {
          if(res){
            this.search();
            this.showSetting = false;
          }
          this.loading = false;
        });
      }
    },
    deletBtn(row, index) {
      this.$Modal.confirm({
        title: this.$notice("deletion"),
        content: "",
        onOk: () => {
          this.loading = true;
          let obj = {
            id: row.id
          }
          axios.post("/LvDaysMaster/deleteLvDaysMaster", obj).then((res) => {
            this.search();
            this.loading = false;
          });
        },
      });
    },
    cancelLeaveData(){
      this.showSetting = false
    },
  },
};
</script>

<style scoped>
.weight-style {
  position: absolute;
  top: 0;
  right: 0;
  display: table-cell;
  white-space: nowrap;
  padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/LvDaysMaster.vue